<form [formGroup]="kostenGehandicaptKind">
    <div *ngIf="pgaKostenGehandicaptKind.length > 0">
        <div formArrayName="pgaKostenGehandicaptKind">
            <div *ngFor="let item of pgaKostenGehandicaptKind.controls; let i = index;"
                 [formGroupName]="i" class="row">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Voorletter(s) en achternaam' : ''"
                                                class="col-auto custom-input-250"
                                                formControlName="naam"
                                                id="naam"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-date-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Geboortedatum' : ''"
                                                [required]=true
                                                class="col-auto custom-input-150"
                                                formControlName="geboortedatumKind"
                                                id="geboortedatumKind"
                                                placeholder="dd-mm-jjjj"

                >
                </snelstart-ui-date-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Dagen verzorging p/j' : ''"
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="dagenVerzorging"
                                                  id="dagenVerzorging"

                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Dagen gereisd p/j' : ''"
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="dagenGereisd"
                                                  id="dagenGereisd"

                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Km\'s enkele reis' : ''"
                                                  align="right"
                                                  class="col-auto custom-input-150"
                                                  formControlName="afstandEnkeleReis"
                                                  id="afstandEnkeleReis"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Ontvangen vergoeding' : ''"
                                                  align="right"
                                                  class="col-auto custom-input-175"
                                                  formControlName="vergoeding"
                                                  id="vergoeding"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="verwijderRijKostenGehandicaptKind(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                     iconType="light"
                                     id="buttonDeleteKosten"
                                     icon="trash"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>
</form>

<div *ngIf="pgaKostenGehandicaptKind.length === 0">
    <snelstart-ui-button (click)="addRijKostenGehandicaptKind()" class="snelstart-ui-button" icon="plus"
                         type="link">Weekenduitgaven
    </snelstart-ui-button>
</div>
<div *ngIf="pgaKostenGehandicaptKind.length > 0">
    <snelstart-ui-button (click)="addRijKostenGehandicaptKind()" class="snelstart-ui-button" icon="plus"
                         type="link">Weekenduitgaven toevoegen
    </snelstart-ui-button>
</div>


<div *ngIf="hasKindJongerDan21()">
    <div class="space20"></div>
    <snelstart-ui-alert type="warning">
        Let op: De aftrekpost 'Weekenduitgaven gehandicapte kinderen' is alleen voor kinderen die in het
        aangiftejaar {{ this.incomeTaxEntity.aangifte?.aangifteJaar }} 21 jaar of ouder zijn.
    </snelstart-ui-alert>
</div>
